import { createPusherEvent } from '../../pusher';
import { PusherChannel, PusherEventName } from '../../pusher/types';
import { CoursePusherEvent } from '../courses/pusher-events';
import { AttendanceWarningAction } from './types';

export type ClassPusherEvent<T extends {} = never> = CoursePusherEvent<T> & {
  classId: MongoId;
};

export type AttendanceMarkedEvent = ClassPusherEvent<{
  attendanceTime: UnixTime;
  attendee: MongoId;
  count: number;
  /** @deprecated - not used in ppt addon */
  sender: unknown;
  /** @deprecated - not used in ppt addon */
  studentId: unknown;
}>;

export const attendanceMarkedEvent = createPusherEvent<AttendanceMarkedEvent>(
  PusherEventName.ATTENDANCE_MARKED,
  {
    channels: [PusherChannel.USER],
  }
);

export type AttendanceWarningEvent = ClassPusherEvent<{
  /**
   * `showWarning` means attendance is started
   * `hideWarning` means attendance is stopped
   */
  action: AttendanceWarningAction;
  /** @deprecated - not used in ppt addon */
  isProxy: NumericBoolean;
  /** @deprecated - not used in ppt addon */
  attendanceTime: UnixTime;
  /** @deprecated - not used in ppt addon */
  scheStartTime: UnixTime;
  /** @deprecated - not used in ppt addon */
  /** whether class is automatically started, because of a scheduled attendance */
  classAutoStarted: NumericBoolean;
  /** @deprecated - not used in ppt addon */
  /** ignore, if classAutoStarted === 0 */
  classStartedAt: UnixTime;
  /** @deprecated - not used in ppt addon */
  /** ignore, if classAutoStarted === 0 */
  /** @deprecated - not used in ppt addon */
  classTrueNum: number;
  /** @deprecated - not used in ppt addon */
  wasScheduled: NumericBoolean;
  /** @deprecated - not used in ppt addon */
  numEnrolled: number;
  /** @deprecated - not used in ppt addon */
  numAvailable: number;
  /** @deprecated - not used in ppt addon */
  numPresent: number;
  /** @deprecated - not used in ppt addon */
  sender: unknown;
}>;

export const attendanceWarningEvent = createPusherEvent<AttendanceWarningEvent>(
  PusherEventName.WEB_ATTENDANCE_WARNING,
  { channels: [PusherChannel.COURSE], ignoreForSameUser: false }
);
